import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Check, Copy } from "lucide-react";

const CopyButton = ({ value, size = 13, sx = {} }) => {
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <Tooltip title={copied ? "Copied!" : "Copy"} placement="top" arrow>
      <IconButton
        size="small"
        onClick={handleCopy}
        sx={{
          p: "2px",
          color: copied ? "hsl(142 71% 45%)" : "hsl(150 10% 46%)",
          "&:hover": { color: "hsl(142 71% 45%)", background: "transparent" },
          ...sx,
        }}
      >
        {copied ? <Check size={size} strokeWidth={2} /> : <Copy size={size} strokeWidth={1.8} />}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
